import { CirclePlus } from "lucide-react";
import { Button } from "./Button";
import usePermissions from "../../../hooks/usePermissions";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const CreateButtonTrigger = forwardRef((props, ref) => {
  const permissions = usePermissions();
  const hasCreatePermissions = permissions.canCreate();
  const { t } = useTranslation();

  return (
    hasCreatePermissions && (
      <Button {...props} className="h-7 gap-1" ref={ref}>
        <span className="sr-only sm:not-sr-only sm:whitespace-nowrap">
          {t("defaults.createLabel")}
        </span>
        <CirclePlus className="sm:hidden" />
      </Button>
    )
  );
});

export default CreateButtonTrigger;
